import { render, staticRenderFns } from "./ed-edupad-editor.vue?vue&type=template&id=65d6d152&scoped=true&"
import script from "./ed-edupad-editor.ts?vue&type=script&lang=ts&"
export * from "./ed-edupad-editor.ts?vue&type=script&lang=ts&"
import style0 from "./ed-edupad-editor.scss?vue&type=style&index=0&id=65d6d152&lang=scss&scoped=true&"
import style1 from "@/assets/styles/quill.snow.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6d152",
  null
  
)

export default component.exports